/**
 * @generated SignedSource<<9d489adbedc515e8b2b70f93ce62142d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TeamScheduleHistoryMasterListItem_teamSchedule$data = {
  readonly events: ReadonlyArray<{
    readonly " $fragmentSpreads": FragmentRefs<"TeamScheduleStatusRow_teamScheduleEventOccasion">;
  }>;
  readonly id: string;
  readonly label: string;
  readonly " $fragmentType": "TeamScheduleHistoryMasterListItem_teamSchedule";
};
export type TeamScheduleHistoryMasterListItem_teamSchedule$key = {
  readonly " $data"?: TeamScheduleHistoryMasterListItem_teamSchedule$data;
  readonly " $fragmentSpreads": FragmentRefs<"TeamScheduleHistoryMasterListItem_teamSchedule">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TeamScheduleHistoryMasterListItem_teamSchedule",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "label",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "includeInlineRoutines",
          "value": true
        }
      ],
      "concreteType": null,
      "kind": "LinkedField",
      "name": "events",
      "plural": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "TeamScheduleStatusRow_teamScheduleEventOccasion"
        }
      ],
      "storageKey": "events(includeInlineRoutines:true)"
    }
  ],
  "type": "TeamSchedule",
  "abstractKey": null
};

(node as any).hash = "1c42baebb62c634c0eaa01057e79a187";

export default node;
